import { OrganizacaoSimples } from './organizacao.interface';
import { UnidadeSimples } from './unidade.interface';
import { Usuario } from './usuario.interface';

export class Secretaria implements Usuario {
  id?: string;
  primeiro_nome: string; 
  sobrenome: string; 
  idade: string | Date; 
  endereco:string; 
  cidade: string; 
  estado: string; 
  telefone: string; 
  email: string;
  tipo_usuario: 'secretaria'; 
  url?: string;
  medicos: Array<{ id: string}>;
  enfermeiros: Array<{ id: string}>;
  bloqueado: boolean;

  // Os atributos abaixo são do formato antigo pode estar sendo usado por algum usuario, por isso não foram removidos
  medico?: {
    id: string;
    email: string;
    permissao: string 
  };
  enfermeiro?: {
    id: string;
    email: string;
    permissao: string 
  };
  ativa?: boolean;
  hash?: string;
  nome?: string;
  data_criacao?: string | Date
  orgs?: Array<OrganizacaoSimples>;
  unidades?: Array<UnidadeSimples>;

  constructor(secretaria: Secretaria) {
    this.id = secretaria.id;
    this.primeiro_nome = secretaria.primeiro_nome;
    this.sobrenome = secretaria.sobrenome;
    this.idade = secretaria.idade;
    this.endereco = secretaria.endereco;
    this.cidade = secretaria.cidade;
    this.estado = secretaria.estado;
    this.telefone = secretaria.telefone;
    this.email = secretaria.email;
    this.tipo_usuario = 'secretaria';
    this.url = secretaria.url;
    this.medicos = secretaria.medicos;
    this.enfermeiros = secretaria.enfermeiros;
    this.bloqueado = secretaria.bloqueado;
    this.orgs = secretaria.orgs;
    this.unidades = secretaria.unidades;
  }

  static create(secretaria: {
    primeiro_nome: string,
    sobrenome: string,
    idade: string,
    endereco: string,
    cidade: string,
    estado: string,
    telefone: string,
    email: string,
    ativado: boolean,
    bloqueado: boolean,
    medicos: Array<{ id: string}>
    orgs?: Array<OrganizacaoSimples>;
    unidades?: Array<UnidadeSimples>;
  }) {
    return {
      primeiro_nome: secretaria.primeiro_nome,
      sobrenome: secretaria.sobrenome,
      idade: secretaria.idade,
      endereco: secretaria.endereco,
      cidade: secretaria.cidade,
      estado: secretaria.estado,
      telefone: secretaria.telefone,
      email: secretaria.email,
      ativado: false,
      bloqueado: false,
      tipo_usuario: 'secretaria',
      medicos: secretaria.medicos,
      enfermeiros: [],
      orgs: secretaria.orgs,
      unidades: secretaria.unidades,
    };
  }

  static createEmpty() {
    return {
      id: undefined,
      primeiro_nome: '',
      sobrenome: '',
      idade: '',
      endereco: '',
      cidade: '',
      estado: '',
      telefone: '',
      email: '',
      ativado: false,
      bloqueado: false,
      tipo_usuario: 'secretaria',
      medicos: [],
      enfermeiros: [],
      orgs: [],
      unidades: []
    } as Secretaria;
  }
}